import React from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    variant?: ButtonVariant;
    size?: ButtonSize;
    isLoading?: boolean;
    className?: string;
}

export default function Button({ children, className = '', disabled = false, isLoading = false, ...props }: ButtonProps) {
    return (
        <button type='button' className={className || 'bs-button-component'} disabled={disabled || isLoading} {...props}>
            {isLoading ? 'Loading...' : children}
        </button>
    );
}
